import AgentStatsDialogs from "./AgentStatsDialogs";
import AgentStatsLeads from "./AgentStatsLeads";
import AgentStatsConversionRate from "./AgentStatsConversionRate";
import AgentStatsAverageTime from "./AgentStatsAverageTime";

export const AgentStats = () => {
  return (
    <div>
      <h1>Аналитика агента</h1>
      <section className="flex flex-row gap-4 flex-wrap">
        <div className="flex-1">
          <AgentStatsDialogs month={1} />
        </div>
        <div className="flex-1">
          <AgentStatsLeads month={1} />
        </div>
        <div className="flex-1">
          <AgentStatsConversionRate month={1} />
        </div>
        <div className="flex-1">
          <AgentStatsAverageTime month={1} />
        </div>
      </section>
    </div>
  );
};
